import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SDGComponent } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class SDGComponentService {
    constructor(private http: HttpClient) { }
    getAll(component_id : number) {
        return this.http.get<SDGComponent>(URL+'pss_app/component/'+component_id+'/');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/sdgcomponent.service.ts